import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const ConfigurationContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4rem;
  font-family: quicksand;
  background-color: ${colors.WHITE};
  padding: 4rem 3rem;
  border-radius: 1rem;
`;

export const ConfigurationItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const CheckboxItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: max-content;
`;

export const ExamDuration = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const headerText = {
  color: colors.BLACK,
  fontSize: '1.5rem',
  fontFamily: 'quicksand',
  fontWeight: 'bold',
};

export const checkboxText = {
  color: colors.GRAY_DARKER,
  fontFamily: 'quicksand',
  fontWeight: 'bold',
};

export default {
  ConfigurationContainer,
  ConfigurationItems,
  ExamDuration,
  CheckboxItem,
  headerText,
  checkboxText,
};
